module.exports = __webpack_public_path__ + "img/school_csmd1.27661f30.png";